/* Version 5 of the calendar */
function generateCalendar(events) {

    var $events = events;
    var $calendar = document.getElementById('calendar');
    
    if($calendar) {

        console.log("%cCalendrier pour la Ville de Port-Cartier", "color:white; background-color:#003056");
        console.log($events);

        the__calendar = new FullCalendar.Calendar($calendar, {
            plugins: [ 'dayGrid', 'moment', 'interaction' ],
            defaultView: 'dayGridMonth',
            lazyFetching: true,
            header: {
                left:   'prev',
                center: 'title',
                right:  'next'
            },
            columnHeader: true,
            locale: 'fr',
            titleFormat: {
                month: 'long',
                year: 'numeric'
            },
            dateClick: function(info) {
                console.log('Date: ' + info.dateStr);
            },
            eventClick: function(info) {
                console.log(info.event.id);
                // Calendar.displayEvent(info.event.id); 
            }, 
            events: $events
        });

        the__calendar.render();

    }
    else {
        console.error('Erreur : Aucun calendrier trouvé.');
    }
}

function events__filters_reset() {

    $('input[name="filter__date_start"]').val('');
    $('input[name="filter__date_end"]').val('');
    $('input[name="filter__event_name"]').val('');
    $('input[name="terms[]"]').prop('checked', false);
    $('input[name="terms[]"]').last().prop('checked', true);

    return false;
}

function event__disable_buttons() {
    // Source : https://stackoverflow.com/questions/4702000/toggle-input-disabled-attribute-using-jquery
    $('.event__filter_buttons').prop('disabled', function(i, v) { return !v; });
}

/* Picked from V4 */

var Calendar = function () {
    
    return {

        init: function() {

            console.log('Calendar V5 init.');

            $('.single__event .btn__details').bind('click', function(e) {

                e.preventDefault();

                $(this).parents('.single__event').toggleClass('collapsed');

                if($(this).parents('.single__event').hasClass('collapsed')) {

                    $(this).html("<i class='fal fa-plus'></i> Détails");
                }
                else {
                    $(this).html("<i class='fal fa-minus'></i> Masquer");
                }
            });

        },

        displayEventFromDetailButton: function(e) {
            
            event.preventDefault();

            $(event.target).parents('.single__event').toggleClass('collapsed');

            if($(event.target).parents('.single__event').hasClass('collapsed')) {

                $(event.target).html("<i class='fal fa-plus'></i> Détails");
            } 
            else {
                $(event.target).html("<i class='fal fa-minus'></i> Masquer");
            }
        },

        displayEvent: function( event_id ) {

            $('.single__event').addClass('collapsed');

            checkCollapsed();

            TweenLite.to(window, 1, {scrollTo:{y:$('.single__event[data-event-id="' + event_id +'"]').first().offset().top, offsetY:0, autoKill:toggleEventDetails(event_id)}});
        },

        checkHashtag: function() {

            if(window.location.hash) {

                setTimeout(function() {

                    TweenLite.to(window, 0, {scrollTo:window.location.hash});

                    $('#'+window.location.hash.substring(1)).removeClass('collapsed');

                    if($('#'+window.location.hash.substring(1)).hasClass('collapsed')) {

                        $('#'+window.location.hash.substring(1)).find('.btn__details').html("<i class='fal fa-plus'></i> Détails");
                    }
                    else {
                        $('#'+window.location.hash.substring(1)).find('.btn__details').html("<i class='fal fa-minus'></i> Masquer");
                    }

                }, 450);
                
            }

        },

        events__filter_select_term: function(e) {

            var selected__term = $(e).attr('data-term');

            if( selected__term == 'term-all' ) {
                
                $(".event__filters input[name='terms[]']").not(':last').prop('checked', false);  
            }
            else {

                $(".event__filters input[name='terms[]']").last().prop('checked', false);      
            }
        }
    };

}();


$(document).ready(function () {

    if($('#calendar').length > 0) {

        Calendar.init();
        Calendar.checkHashtag();
    }

});


/*
document.addEventListener('DOMContentLoaded', function() {

    var event__calendar = document.getElementById('calendar');

    if(event__calendar) {

        the__calendar = new FullCalendar.Calendar(event__calendar, {
            plugins: [ 'dayGrid', 'moment', 'interaction' ],
            defaultView: 'dayGridMonth',
            lazyFetching: true,
            header: {
                left:   'prev',
                center: 'title',
                right:  'next'
            },
            columnHeader: true,
            locale: 'fr',
            titleFormat: {
                month: 'long',
                year: 'numeric'
            },
            dateClick: function(info) {
                console.log('Date: ' + info.dateStr);
            },
            eventClick: function(info) {
                console.log(info.event.id);

                Calendar.displayEvent(info.event.id); 
            }, 
            events: function(info, successCallback, failureCallback) {

                $('.fc__start_date').val(info.start.toString());
                $('.fc__end_date').val(info.end.toString());

                var mydata = {
                    action: "calendar_render_default", 
                    //start:format_date(info.start.toString()),
                    //end:format_date(info.end.toString())
                    args: $('.temp__args').text()
                };

                // Toggle loading animations on results
                //$('.event__list').toggleClass('loading').html('');
                $('.event__calendar').toggleClass('loading');


                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: mydata,
                    dataType: 'json',
                    success:function(results) {
                        var events = [];
                        if(!!results){
                            $.map( results.data, function( r ) {
                                
                                var eventContainer = '';

                                // FC event array
                                events.push({
                                    id: r.id,
                                    title: r.title,
                                    start: r.start,
                                    end: r.end,
                                    classNames : r.classNames,
                                    typeNames: r.typeNames,
                                    eventContent: r.eventContent,
                                    eventEndroit: r.eventEndroit,
                                    postName: r.postName,
                                    postThumbnail: r.postThumbnail,
                                    startDay: r.startDay,
                                    startMonth: r.startMonth,
                                    frenchStartDate: r.frenchStartDate,
                                    allDay: r.allDay,
                                    startHour: r.startHour,
                                    endHour: r.endHour
                                });
                                //$('.event__list').toggleClass('loading').append(eventContainer);
                                setTimeout(function() {
                                    $('.event__calendar').toggleClass('loading');
                                    console.log('TEST');
                                },250);
                                
                                
                            });
                        }

                        successCallback(events);

                        
                    }
                })
            },
            remove: function() {

                alert('Element removed.');
            }
        });

        
        the__calendar.render();
    } 

    $(".fc-prev-button").click(function () { });
    
    $(".fc-next-button").click(function () { });
});
*/

function toggleEventDetails(event_id) {

    setTimeout(function(){

        $('.single__event[data-event-id="' + event_id + '"]').toggleClass('collapsed');

        checkCollapsed();

    }, 250);
}


function checkCollapsed() {

    $('.single__event').each(function(element) {

        if($(this).hasClass('collapsed')) {

            $(this).find('.btn__details').html("<i class='fal fa-plus'></i> Détails");
        }
        else {
            $(this).find('.btn__details').html("<i class='fal fa-minus'></i> Masquer");
        }
    });
}


var serializeArray = function (form) {

    // Setup our serialized data
    var serialized = [];

    // Loop through each field in the form
    for (var i = 0; i < form.elements.length; i++) {

        var field = form.elements[i];

        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

        // Convert field data to a query string
        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized.push({
                field: field.name,
                value: field.value 
            });
        }
    }

    return serialized;
};


function format_date( date ){

    if (typeof date == "string") {
        date = new Date(date);
    }

    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return year+'-'+month+'-'+day;
};


function renderSplitTypeNames(typeNames) {

    var splitTypesNaes = typeNames.split(", ");

    // Display array values on page
    for(var i = 0; i < strArray.length; i++){
        document.write("<p>" + strArray[i] + "</p>");
    }

}